import React from 'react'
import axios from 'axios'
import { observer } from 'mobx-react'
import { Button, Grid, Card } from '@softwaredev_cegeka/stix-core'
import BaseForm from 'src/components/Forms/BaseForm'
import Notice from 'src/components/Notice'
import { authenticatedUserStore, notifierStore } from 'src/stores'
import { AuthApi } from 'src/api/authApi'
import './groupForm.scss'

class GlobalAdminForm extends BaseForm {
    state = {
        activePageNumber: 0,
        columnSizes: { md: 3 },
        errors: {},
        isSubmitting: false,
        submittedSuccessfully: false,
        userCreated: null,
        touched: {},
        values: {},
        uploadProgress: null,
        userIsTenantAdmin: false,
        loading: true,
    }

    initialValues = {
        lastName: '',
        firstName: '',
        username: '',
        tenant: '',
        email: '',
        localUser: false,
        locked: false,
        groups: null,
        initialGroups: [],
        global_admin_from: null,
        global_admin_until: null,
        is_global_admin: false,
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    constructor(props, context) {
        super(props, context)
        this.state.values = { ...this.initialValues }
        if (props.userData.username) {
            this.fetchAndSetUser(props.userData.username)
        }
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    getSubmitUrl() {
        return `/api/auth/global-admins`
    }

    fetchAndSetUser(username) {
        this.state.loading = true
        this.authClient.fetchUser(username).then(response => {
            this.initialValues = {
                global_admin_from: response.data.global_admin_from,
                global_admin_until: response.data.global_admin_until,
                is_global_admin: response.data.is_global_admin,
            }
            this.setState({
                loading: false,
                values: { ...this.initialValues },
            })
        })
    }

    generateGeneralInfoPayload = () => {
        return {
            username: this.props.userData.username,
        }
    }

    submitGeneralInfo = async () => {
        const payload = this.generateGeneralInfoPayload()
        notifierStore.setShowMessage(false)
        try {
            let resp = await axios({
                url: this.getSubmitUrl(),
                method: 'POST',
                data: payload,
            })
            if (resp.status === 200) {
                notifierStore.setToastInfo(
                    'Global admin request is successfully submitted',
                    true
                )
                this.fetchAndSetUser(this.props.userData.username)
            } else {
                notifierStore.setToastInfo(
                    'Global admin request is failed',
                    false
                )
            }
        } catch (ex) {
            console.warn('API Exception', ex)
            notifierStore.setToastInfo(
                ex.response?.data?.error || ex.response?.data?.detail,
                false
            )
        } finally {
            notifierStore.setShowMessage(true)
        }
    }

    // overwrite this in order to render the buttons separately
    renderFormActions(pageNumber) {
        return null
    }

    render() {
        return (
            <Grid.Container>
                <div className={'page-header'}>
                    <h1 className="content-title">
                        Request global admin access
                    </h1>
                </div>
                <div className={'request-global-admin-wizard'}>
                    <Card>
                        <Card.Body>
                            <Notice
                                title={'IMPORTANT NOTICE'}
                                loading={this.state.loading}
                                isGlobalAdmin={
                                    this.state.values.is_global_admin
                                }
                                globalAdminFrom={
                                    this.state.values.global_admin_from
                                }
                                globalAdminUntil={
                                    this.state.values.global_admin_until
                                }
                            />
                            <Button
                                className={'mb-3'}
                                size={'sm'}
                                key={'submit'}
                                variant={'secondary'}
                                label={'I understand'}
                                onClick={this.submitGeneralInfo}
                            >
                                Submit
                            </Button>
                        </Card.Body>
                    </Card>
                </div>
            </Grid.Container>
        )
    }
}

export default observer(GlobalAdminForm)
